const InstagramIcon = ({ isDisable }: Props) => {
  const opacity = isDisable ? "0.2" : 1;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={opacity}>
        <circle cx="12" cy="12" r="12" fill="#E1306C" />
        <rect x="7.2" y="7.2" width="9.6" height="9.6" rx="2.4" fill="white" />
        <circle cx="12" cy="12" r="2.4" fill="#E1306C" />
        <circle cx="15.2" cy="8.8" r="0.8" fill="#E1306C" />
      </g>
    </svg>
  );
};
const deleteButton = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 4.20825H14" stroke="#EB5959" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.5 4.20825H12.5V13.2083C12.5 13.4735 12.3946 13.7278 12.2071 13.9154C12.0196 14.1029 11.7652 14.2083 11.5 14.2083H4.5C4.23478 14.2083 3.98043 14.1029 3.79289 13.9154C3.60536 13.7278 3.5 13.4735 3.5 13.2083V4.20825Z"
      stroke="#EB5959"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 4.20825V3.70825C5.5 3.04521 5.76339 2.40933 6.23223 1.94049C6.70107 1.47164 7.33696 1.20825 8 1.20825C8.66304 1.20825 9.29893 1.47164 9.76777 1.94049C10.2366 2.40933 10.5 3.04521 10.5 3.70825V4.20825"
      stroke="#EB5959"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.5 7.20972V11.2112" stroke="#EB5959" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.5 7.20972V11.2112" stroke="#EB5959" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const ActionIcon = (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 2638">
      <path id="Vector" d="M14.668 3.33301H10.668" stroke="#86878a" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path id="Vector_2" d="M4.00065 3.33301H1.33398" stroke="#86878a" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path
        id="Vector_3"
        d="M6.66732 5.66667C7.95598 5.66667 9.00065 4.622 9.00065 3.33333C9.00065 2.04467 7.95598 1 6.66732 1C5.37865 1 4.33398 2.04467 4.33398 3.33333C4.33398 4.622 5.37865 5.66667 6.66732 5.66667Z"
        stroke="#86878a"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path id="Vector_4" d="M14.6667 10.667H12" stroke="#86878a" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path id="Vector_5" d="M5.33398 10.667H1.33398" stroke="#86878a" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path
        id="Vector_6"
        d="M9.33333 12.9997C10.622 12.9997 11.6667 11.955 11.6667 10.6663C11.6667 9.37768 10.622 8.33301 9.33333 8.33301C8.04467 8.33301 7 9.37768 7 10.6663C7 11.955 8.04467 12.9997 9.33333 12.9997Z"
        stroke="#86878a"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const activityIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect y="0.000366211" width="40" height="40" rx="20" fill="#595A61" fillOpacity="0.1"></rect>
    <path
      d="M15.1806 15.8151C15.0878 15.6825 15.1827 15.5004 15.3445 15.5004H21.6636C21.7243 15.5004 21.7818 15.528 21.8197 15.5754L22.1419 15.3177L21.8197 15.5754L25.2597 19.8754C25.3182 19.9485 25.3182 20.0523 25.2597 20.1253L21.8197 24.4253C21.7818 24.4727 21.7243 24.5004 21.6636 24.5004H15.3445C15.1827 24.5004 15.0878 24.3182 15.1806 24.1857L14.7748 23.9016L15.1806 24.1857L17.6286 20.6885C17.9178 20.2753 17.9178 19.7254 17.6286 19.3122L15.1806 15.8151Z"
      stroke="#495057"
    ></path>
  </svg>
);

const editButton = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.84006 2.4L3.36673 8.19334C3.16006 8.41334 2.96006 8.84667 2.92006 9.14667L2.6734 11.3067C2.58673 12.0867 3.14673 12.62 3.92006 12.4867L6.06673 12.12C6.36673 12.0667 6.78673 11.8467 6.9934 11.62L12.4667 5.82667C13.4134 4.82667 13.8401 3.68667 12.3667 2.29334C10.9001 0.913335 9.78673 1.4 8.84006 2.4Z"
      stroke="#0475F0"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003"
      stroke="#0475F0"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 14.6667H14" stroke="#0475F0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const logoutIcon = (
  <svg width="250" height="200" viewBox="0 0 250 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M136 64C139.866 64 143 67.134 143 71C143 74.866 139.866 78 136 78H200C203.866 78 207 81.134 207 85C207 88.866 203.866 92 200 92H222C225.866 92 229 95.134 229 99C229 102.866 225.866 106 222 106H203C199.134 106 196 109.134 196 113C196 116.866 199.134 120 203 120H209C212.866 120 216 123.134 216 127C216 130.866 212.866 134 209 134H157C156.485 134 155.983 133.944 155.5 133.839C155.017 133.944 154.515 134 154 134H63C59.134 134 56 130.866 56 127C56 123.134 59.134 120 63 120H24C20.134 120 17 116.866 17 113C17 109.134 20.134 106 24 106H64C67.866 106 71 102.866 71 99C71 95.134 67.866 92 64 92H39C35.134 92 32 88.866 32 85C32 81.134 35.134 78 39 78H79C75.134 78 72 74.866 72 71C72 67.134 75.134 64 79 64H136ZM226 120C229.866 120 233 123.134 233 127C233 130.866 229.866 134 226 134C222.134 134 219 130.866 219 127C219 123.134 222.134 120 226 120Z"
      fill="#F3F7FF"
    />
    <path
      d="M144.534 44H77.4664C74.4474 44 72 46.4474 72 49.4664V150.534C72 153.553 74.4474 156 77.4664 156H144.534C147.553 156 150 153.553 150 150.534V120.7V81.2607V49.4664C150 46.4474 147.553 44 144.534 44Z"
      fill="white"
    />
    <path
      d="M150 81.2607V49.4664C150 46.4474 147.553 44 144.534 44H77.4664C74.4474 44 72 46.4474 72 49.4664V150.534C72 153.553 74.4474 156 77.4664 156H144.534C147.553 156 150 153.553 150 150.534V120.7"
      stroke="#1F64E7"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M141.607 102.341H176M176 102.341L162.562 88.9023M176 102.341L162.562 115.779"
      stroke="#1F64E7"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M127.867 32.2393C130.008 31.82 132 33.4589 132 35.6406V165.33C132 167.518 129.998 169.158 127.853 168.729L73.8174 157.904C72.1887 157.578 71.0206 156.142 71.0322 154.481L71.8037 46.0449C71.8156 44.3968 72.987 42.9847 74.6045 42.668L127.867 32.2393Z"
      fill="white"
      stroke="#1F64E7"
      strokeWidth="4"
    />
    <path d="M73.5 155L74 46C80.6103 108.662 93.5993 133.791 128 166.5L73.5 155Z" fill="#F3F7FF" />
  </svg>
);
const filterEmptyIcon = (
  <svg width="73" height="123" viewBox="0 0 73 123" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="61.5" cy="35.5" r="7.5" transform="rotate(-180 61.5 35.5)" fill="#6F36BC1A" />
    <circle cx="25" cy="7" r="7" transform="rotate(-180 25 7)" fill="#6F36BC1A" />
    <circle cx="5.5" cy="28.5" r="4.5" transform="rotate(-180 5.5 28.5)" fill="#6F36BC1A" />
    <path
      d="M71 53L2 53L28.5385 89.6154L28.5385 121L44.4615 110.538L44.4615 89.6154L71 53Z"
      stroke="#6839b5"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const pinSelected = (
  <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.85355 6.35445H7.71893L6.80355 2.1006H7.04585C7.47662 2.1006 7.82662 1.7506 7.82662 1.31983C7.82662 0.889063 7.47662 0.539062 7.04585 0.539062H2.79201C2.36124 0.539062 2.01124 0.889063 2.01124 1.31983C2.01124 1.7506 2.36124 2.1006 2.79201 2.1006H3.03431L2.14585 6.35445H2.01124C1.58047 6.35445 1.23047 6.70445 1.23047 7.13522C1.23047 7.56598 1.58047 7.91599 2.01124 7.91599H4.27278V12.6006C4.27278 13.0314 4.62278 13.4083 5.08047 13.4083C5.53816 13.4083 5.88816 13.0583 5.88816 12.6006V7.94291H7.88047C8.31124 7.94291 8.66124 7.59291 8.66124 7.16214C8.66124 6.73137 8.28431 6.35445 7.85355 6.35445Z"
      stroke="#595A61"
    />
  </svg>
);

const notepadIconWithoutBg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10 3.5H4C3.44772 3.5 3 3.94772 3 4.5V13.5C3 14.0523 3.44772 14.5 4 14.5H10C10.5523 14.5 11 14.0523 11 13.5V4.5C11 3.94772 10.5523 3.5 10 3.5Z"
      stroke="#595A61"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5 6H9" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 8.5H9" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 11H7" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.5 1.5H12C12.2652 1.5 12.5196 1.60536 12.7071 1.79289C12.8946 1.98043 13 2.23478 13 2.5V12"
      stroke="#595A61"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const emptyInbox = (
  <svg xmlns="http://www.w3.org/2000/svg" width="216" height="90" viewBox="0 0 216 90" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 82H137C137.515 82 138.017 81.9444 138.5 81.8389C138.983 81.9444 139.485 82 140 82H192C195.866 82 199 78.866 199 75C199 71.134 195.866 68 192 68H186C182.134 68 179 64.866 179 61C179 57.134 182.134 54 186 54H205C208.866 54 212 50.866 212 47C212 43.134 208.866 40 205 40H183C186.866 40 190 36.866 190 33C190 29.134 186.866 26 183 26H119C122.866 26 126 22.866 126 19C126 15.134 122.866 12 119 12H62C58.134 12 55 15.134 55 19C55 22.866 58.134 26 62 26H22C18.134 26 15 29.134 15 33C15 36.866 18.134 40 22 40H47C50.866 40 54 43.134 54 47C54 50.866 50.866 54 47 54H7C3.13401 54 0 57.134 0 61C0 64.866 3.13401 68 7 68H46C42.134 68 39 71.134 39 75C39 78.866 42.134 82 46 82ZM209 82C212.866 82 216 78.866 216 75C216 71.134 212.866 68 209 68C205.134 68 202 71.134 202 75C202 78.866 205.134 82 209 82Z"
      fill="#F3F7FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.1186 60.3066C96.0404 60.8599 96 61.4252 96 62C96 68.6274 101.373 74 108 74C114.627 74 120 68.6274 120 62C120 61.4252 119.96 60.8599 119.881 60.3066H149V87C149 88.6569 147.657 90 146 90H70C68.3431 90 67 88.6569 67 87V60.3066H96.1186Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M121 60C121 67.1797 115.18 73 108 73C100.82 73 95 67.1797 95 60C95 59.7674 95.0061 59.5362 95.0182 59.3066H67L76.5604 31.0389C76.9726 29.8202 78.1159 29 79.4023 29H136.598C137.884 29 139.027 29.8202 139.44 31.0389L149 59.3066H120.982C120.994 59.5362 121 59.7674 121 60Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M119.098 60.9545C119.098 66.5025 114.129 72 108 72C101.871 72 96.9024 66.5025 96.9024 60.9545C96.9024 60.7748 96.9077 59.5962 96.918 59.4188H76L84.1614 39.5755C84.5132 38.6338 85.4891 38 86.5873 38H129.413C130.511 38 131.487 38.6338 131.839 39.5755L140 59.4188H119.082C119.092 59.5962 119.098 60.7748 119.098 60.9545Z"
      fill="#E8F0FE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.25 59.5123V86C68.25 86.9665 69.0335 87.75 70 87.75H146C146.966 87.75 147.75 86.9665 147.75 86V59.5123L138.255 31.4393C138.015 30.7285 137.348 30.25 136.598 30.25H79.4023C78.6519 30.25 77.985 30.7285 77.7446 31.4393L68.25 59.5123Z"
      stroke="#1F64E7"
      strokeWidth="2.5"
    />
    <path
      d="M81 59C84.9366 59 89.1849 59 93.7449 59C95.6212 59 95.6212 60.3186 95.6212 61C95.6212 67.6274 101.117 73 107.897 73C114.677 73 120.173 67.6274 120.173 61C120.173 60.3186 120.173 59 122.05 59H147M73.5737 59H76H73.5737Z"
      stroke="#1F64E7"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M133.1 6.30273L122 18.7559M107.1 2V18.7559V2ZM81 6.30273L92.0996 18.7559L81 6.30273Z"
      stroke="#75A4FE"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const crossIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15Z"
      stroke="#EB5959"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path d="M4.84998 11.15L11.15 4.84998" stroke="#EB5959" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M11.15 11.15L4.84998 4.84998" stroke="#EB5959" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);
const checkIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15Z"
      stroke="#0475F0"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path d="M11.15 5.89999L6.94998 11.15L4.84998 9.57499" stroke="#0475F0" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);
const richTextEditorBold = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M3.25342 3.00002C3.25342 2.26669 3.85342 1.66669 4.58675 1.66669H8.00009C9.74675 1.66669 11.1668 3.08669 11.1668 4.83335C11.1668 6.58002 9.74675 8.00002 8.00009 8.00002H3.25342V3.00002Z"
      stroke="#292D32"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.25342 8H9.58675C11.3334 8 12.7534 9.42 12.7534 11.1667C12.7534 12.9133 11.3334 14.3333 9.58675 14.3333H4.58675C3.85342 14.3333 3.25342 13.7333 3.25342 13V8V8Z"
      stroke="#292D32"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const richTextEditorItalic = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6.41357 2H12.5802" stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.41357 14H9.58024" stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.5 2L6.5 14" stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const richTextEditorUnderline = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3.3335 14H12.6668" stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3.3335 2V6.66667C3.3335 9.24667 5.42016 11.3333 8.00016 11.3333C10.5802 11.3333 12.6668 9.24667 12.6668 6.66667V2"
      stroke="#292D32"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const richTextEditorLeftAlign = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M0.5 1H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.5 4H10.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.5 7H7.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.5 13H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.5 10H10.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const richTextEditorCenterAlign = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M0.5 1H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 4H12" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.5 7H10.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.5 13H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 10H12" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const richTextEditorRightAlign = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M13.5 1H0.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.5 4H3.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.5 7H6.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.5 13H0.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.5 10H3.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const richTextEditorUnorderedList = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M1 3C1.27614 3 1.5 2.77614 1.5 2.5C1.5 2.22386 1.27614 2 1 2C0.723858 2 0.5 2.22386 0.5 2.5C0.5 2.77614 0.723858 3 1 3Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 2.5H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1 7.5C1.27614 7.5 1.5 7.27614 1.5 7C1.5 6.72386 1.27614 6.5 1 6.5C0.723858 6.5 0.5 6.72386 0.5 7C0.5 7.27614 0.723858 7.5 1 7.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 7H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1 12C1.27614 12 1.5 11.7761 1.5 11.5C1.5 11.2239 1.27614 11 1 11C0.723858 11 0.5 11.2239 0.5 11.5C0.5 11.7761 0.723858 12 1 12Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 11.5H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const richTextEditorOrderedList = (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M4.5 2.5H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 7H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 11.5H13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.75 1.09875L1.75 3.49999" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 1.60031H1.18749C1.49813 1.60031 1.74996 1.33154 1.74996 1" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 3.5L1.00008 3.5" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.5 8.5H1V8.14487C1 7.89656 1.1323 7.6718 1.33704 7.57227L2.1717 7.16653C2.37114 7.06958 2.5 6.85066 2.5 6.60879C2.5 6.27256 2.25469 6 1.95209 6H1.5625C1.31758 6 1.10923 6.17392 1.03201 6.41667"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 13.0833C1.08767 13.3261 1.32423 13.5 1.60229 13.5L2.02804 13.5C2.38074 13.5 2.66667 13.2202 2.66667 12.875L2.66667 12.7708C2.66667 12.4257 2.38074 12.1458 2.02804 12.1458L1.81517 12.1458H1.97482C2.29814 12.1458 2.56023 11.8893 2.56023 11.5729C2.56023 11.2565 2.29813 11 1.97482 11L1.65551 11C1.38755 11 1.16164 11.1762 1.09214 11.4167"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const richTextEditorLink = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M6.92285 3.69231L8.49985 2.11519C9.98677 0.62827 12.3975 0.62827 13.8845 2.11519C15.3714 3.60211 15.3714 6.01289 13.8845 7.49981L12.3075 9.07692"
      stroke="#595A61"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.0768 12.3077L7.49981 13.8848C6.01288 15.3717 3.60211 15.3717 2.11519 13.8848C0.628269 12.3979 0.62827 9.98713 2.11519 8.50021L3.69219 6.9231"
      stroke="#595A61"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10.1539 5.84613L5.84619 10.1538" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
function AnimeSpinner() {
  return (
    <svg version="1.1" viewBox="0 0 64 64" width="1em" xmlns="http://www.w3.org/2000/svg" className="anime-spinner">
      <circle className="path-gradient" cx="32" cy="32" r="28" fill="none" stroke="url(#sGD)" strokeWidth="6" />
      <path className="path-solid" d="M 32,4 A 28 28,0,0,0,32,60" fill="none" stroke="#000" strokeWidth="6" strokeLinecap="round" />
      <defs>
        <linearGradient id="sGD" gradientUnits="userSpaceOnUse" x1="32" y1="0" x2="32" y2="68">
          <stop stopColor="#000" offset="0.1" stopOpacity="0" className="stop1"></stop>
          <stop stopColor="#000" offset=".9" stopOpacity="1" className="stop2"></stop>
        </linearGradient>
      </defs>
      {/* <animateTransform
        values="0,0,0;360,0,0"
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="850ms">
      </animateTransform> */}
    </svg>
  );
}
const CompletedtickIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00065 14.6667C11.6673 14.6667 14.6673 11.6667 14.6673 8.00001C14.6673 4.33334 11.6673 1.33334 8.00065 1.33334C4.33398 1.33334 1.33398 4.33334 1.33398 8.00001C1.33398 11.6667 4.33398 14.6667 8.00065 14.6667Z"
      stroke="#47A37D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M11 6L7 11L5 9.5" stroke="#47A37D" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const minimizedIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="18" viewBox="0 0 13 18" fill="none">
    <path d="M0.799805 6.60001L6.3998 1.00001" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M12 6.60001L6.4 1.00001" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M12 11.4L6.4 17" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M0.799805 11.4L6.3998 17" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);
const minimizeIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 8H13" stroke="#595A61" strokeLinecap="round" />
  </svg>
);
const modalCloseIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M1.33325 10.6666L10.6666 1.33331" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.6666 10.6666L1.33325 1.33331" stroke="#595A61" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
interface Props {
  isDisable?: boolean;
}
const LinkedinIcon = ({ isDisable }: Props) => {
  const opacity = isDisable ? "0.2" : 1;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={opacity}>
        <circle cx="12" cy="12" r="12" fill="#007AB7" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.61871 10.2453H7.83187V16H9.61871V10.2453ZM9.7648 8.42245C9.7648 7.85031 9.29982 7.38461 8.72856 7.38461C8.15398 7.38461 7.69232 7.85031 7.69232 8.42245C7.69232 8.99459 8.15398 9.46029 8.72856 9.46029C9.29982 9.46029 9.7648 8.99459 9.7648 8.42245ZM12.4518 10.2453H10.7446V16H12.5282V13.1526C12.5282 12.4042 12.6676 11.6757 13.5976 11.6757C14.5143 11.6757 14.5242 12.5339 14.5242 13.2025V16H16.3078V12.8466C16.3078 11.2965 15.9723 10.1056 14.1655 10.1056C13.2954 10.1056 12.7141 10.5813 12.475 11.0337H12.4518V10.2453Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
const TwitterIcon = ({ isDisable }: Props) => {
  const opacity = isDisable ? "0.2" : 1;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={opacity}>
        <circle cx="12" cy="12" r="12" fill="black" />
        <g clipPath="url(#clip0_3384_365636)">
          <mask id="mask0_3384_365636" maskUnits="userSpaceOnUse" x="7" y="7" width="10" height="10">
            <path d="M17 7H7V16.9949H17V7Z" fill="white" />
          </mask>
          <g mask="url(#mask0_3384_365636)">
            <path
              d="M12.9514 11.2321L16.6741 7H15.7919L12.5595 10.6747L9.97773 7H7L10.9041 12.5568L7 16.9949H7.88222L11.2958 13.1143L14.0222 16.9949H17L12.9514 11.2321ZM11.743 12.6058L11.3475 12.0524L8.20009 7.6495H9.55512L12.0951 11.2028L12.4907 11.7561L15.7923 16.3749H14.4373L11.743 12.6058Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3384_365636">
          <rect width="10" height="10" fill="white" transform="translate(7 7)" />
        </clipPath>
      </defs>
    </svg>
  );
};
const FacebookIcon = ({ isDisable }: Props) => {
  const opacity = isDisable ? "0.2" : 1;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={opacity}>
        <circle cx="12" cy="12" r="12" fill="#3D5A96" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8118 16.9231H10.6292V12.2736H9.53845V10.4819H10.6292V9.40713C10.6292 7.94652 11.245 7.07693 12.9947 7.07693H14.4512V8.86864H13.5411C12.8598 8.86864 12.8145 9.11873 12.8145 9.58608L12.8118 10.4819H14.4615L14.2683 12.2736H12.8118V16.9231Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

const FileUploadIcon = ({ color = "#6F36BC", className = "" }: { color?: string; className?: string }) => {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M1.09082 0.5H7.97656L11.5 3.97754V12.9229C11.5 13.0738 11.4392 13.2204 11.3291 13.3291C11.2188 13.4379 11.0678 13.5 10.9092 13.5H1.09082C0.971773 13.5 0.857174 13.4648 0.760742 13.4014L0.670898 13.3291C0.560781 13.2204 0.5 13.0738 0.5 12.9229V1.07715C0.5 0.963828 0.533991 0.852875 0.597656 0.758789L0.670898 0.670898C0.753565 0.589383 0.859191 0.534359 0.973633 0.511719L1.09082 0.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.72716 6.46146L6.54534 4.30762L4.36353 6.46146" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.54541 4.30762L6.54541 10.2307" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
const DragIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="10" cy="3.5" r="1" fill="#595A61" />
    <circle cx="10" cy="6.5" r="1" fill="#595A61" />
    <circle cx="10" cy="9.5" r="1" fill="#595A61" />
    <circle cx="10" cy="12.5" r="1" fill="#595A61" />
    <circle cx="6" cy="3.5" r="1" fill="#595A61" />
    <circle cx="6" cy="6.5" r="1" fill="#595A61" />
    <circle cx="6" cy="9.5" r="1" fill="#595A61" />
    <circle cx="6" cy="12.5" r="1" fill="#595A61" />
  </svg>
);

export {
  deleteButton,
  editButton,
  notepadIconWithoutBg,
  emptyInbox,
  richTextEditorBold,
  richTextEditorLink,
  richTextEditorOrderedList,
  richTextEditorUnorderedList,
  richTextEditorRightAlign,
  richTextEditorCenterAlign,
  richTextEditorLeftAlign,
  richTextEditorUnderline,
  richTextEditorItalic,
  CompletedtickIcon,
  minimizedIcon,
  minimizeIcon,
  modalCloseIcon,
  AnimeSpinner,
  filterEmptyIcon,
  LinkedinIcon,
  TwitterIcon,
  FacebookIcon,
  InstagramIcon,
  FileUploadIcon,
  ActionIcon,
  DragIcon,
  pinSelected,
  activityIcon,
  crossIcon,
  checkIcon,
  logoutIcon,
};
